import { FC } from 'react';

import { BasketItem, BasketItemRetake } from 'store/basket/basketAPI';
import { ExamCard as ExamCardBase } from 'components';

import { FormFields } from '@britishcouncil/react-forms';

export const ExamCard: FC<{
  item: BasketItem;
  fields: FormFields<BasketItemRetake>;
  awardingBodyId: number | undefined;
}> = ({ item }) => {
  return <ExamCardBase exam={item} onlyMainParams></ExamCardBase>;
};
